"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceChip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
/**
 * Chipを複数並べて1つを選択するコンポーネント
 *
 * @param listItems 選択項目情報 { value: inputの値 label: 表示文言 }
 * @param onClick チップ選択イベント（引数は選択中のvalue）
 * @param repeat 横に並べて改行するまでの数（デフォルト: 2）
 * @param disabled ボタンの押下可否
 */
var ChoiceChip = function (_a) {
    var listItems = _a.listItems, _b = _a.onClick, onClick = _b === void 0 ? null : _b, _c = _a.repeat, repeat = _c === void 0 ? 2 : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var _e = (0, react_1.useState)(0), select = _e[0], setSelect = _e[1];
    var handleClick = function (select) {
        onClick && onClick(listItems[select].value);
        setSelect(select);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 3,
        }, children: listItems.map(function (_a, i) {
            var value = _a.value, label = _a.label;
            return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", color: i === select ? 'default' : 'textSecondary', children: label }), variant: "filled", color: i === select ? 'secondary' : 'default', onClick: function () { return handleClick(i); }, disabled: disabled }));
        }) }));
};
exports.ChoiceChip = ChoiceChip;
